import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import * as Actions from '../../store/orders/import/orders.import.actions';
import { OrderImportMappingsRenameModal } from '../../components/modals/order-import-mappings-rename-modal';

const mapStateToProps = (state) => {
  return {
    mappingName: Global.selectOrdersImportMappingName(state),
    mappings: Global.selectOrdersImportMappings(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    renameSavedMapping: (savedMappingName, updatedName) => {
      dispatch(Actions.renameSavedMapping(savedMappingName, updatedName));
    },
  };
};

export const OrderImportMappingsRenameModalContainer = connect(mapStateToProps, mapDispatchToProps)(OrderImportMappingsRenameModal);
